import { getEnv } from './envConfig'
let env = getEnv()

export const ENDPOINT = env.ENDPOINT
export const KEYCLOAK_URL = env.KEYCLOAK_URL

export const USERS = '/api/users';
export const ROLES = '/api/roles';
export const companyRegistration = '/api/restaurant/company'

// Data Setups
export const CATEGORY = '/api/restaurant/categories'
export const SUBCATEGORY = '/api/restaurant/subcategories'
export const MENU_ITEM = '/api/restaurant/menuitems'
export const ITEM_VARIATION = '/api/restaurant/itemvariations'
export const MODIFIER = '/api/restaurant/modifiers'
export const MODIFIER_OPTION = '/api/restaurant/modifieroptions'
export const FREQUENTLY_BOUGHT_TOGETHER = '/api/restaurant/menuitems/frequently-bought-together'
export const TABLE = '/api/restaurant/tables'
export const OFFER = '/api/restaurant/offers'
export const OFFER_ITEM = '/api/restaurant/offeritems'
export const DISCOUNT = '/api/restaurant/discounts'
export const PUBLIC_MENU = '/api/restaurant/menu'
export const CUSTOMER = '/api/restaurant/customers'
export const EMPLOYEE = '/api/restaurant/employees'
export const PAYMENTS = "/api/restaurant/payments"
export const LOGIN = '/api/restaurant/auth/login'

// Dashboard
export const DASHBOARD = '/api/restaurant/dashboard'

// Orders
export const ORDER = '/api/restaurant/orders'
export const ORDER_ITEM = '/api/restaurant/orderitems'
export const KDS = '/api/restaurant/kds'

// Restaurant Ratings
export const RESTAURANT_RATING = '/api/restaurant/restaurant-ratings'

// Stock Management
export const STOCK = '/api/restaurant/stocks'

// Kitchen & Inventory
export const RAW_ITEM_CATEGORY = '/api/restaurant/raw-item-categories'
export const RAW_ITEM = '/api/restaurant/rawitems'
export const RAW_ITEM_BATCH = '/api/restaurant/raw-item-batches'
export const RAW_ITEM_MAPPING = '/api/restaurant/rawitems/mappings'
export const RAW_ITEM_MAPPING_BULK = '/api/restaurant/rawitems/menu-item'
export const KITCHEN = '/api/restaurant/kitchens'
export const GRN = '/api/restaurant/grns'
export const STOCK_ADJUSTMENT = '/api/restaurant/stock-adjustments'
export const SUPPLIER = '/api/restaurant/suppliers'

// image upload paths
export const IMAGE_UPLOAD_PATH = '/api/restaurant/uploads'

// Financial Reports
export const FINANCIAL_REPORTS_SALES = '/api/restaurant/financial-reports/sales'
export const FINANCIAL_REPORTS_PROFIT_LOSS = '/api/restaurant/financial-reports/profit-loss'
export const FINANCIAL_REPORTS_CASH_FLOW = '/api/restaurant/financial-reports/cash-flow'
export const FINANCIAL_REPORTS_SUMMARY = '/api/restaurant/financial-reports/summary'
export const FINANCIAL_REPORTS_COGS = '/api/restaurant/financial-reports/cogs'
export const FINANCIAL_REPORTS_REVENUE_CATEGORY = '/api/restaurant/financial-reports/revenue-category'

// Stock Reports
export const STOCK_REPORTS_CURRENT_STOCK = '/api/restaurant/stock-reports/current'
export const STOCK_REPORTS_LOW_STOCK = '/api/restaurant/stock-reports/low-stock'
export const STOCK_REPORTS_EXPIRING_ITEMS = '/api/restaurant/stock-reports/expiring-items'
export const STOCK_REPORTS_VALUATION = '/api/restaurant/stock-reports/valuation'
export const STOCK_REPORTS_MOVEMENT = '/api/restaurant/stock-reports/movement'
export const STOCK_REPORTS_CONSUMPTION = '/api/restaurant/stock-reports/consumption'
export const STOCK_REPORTS_SUMMARY = '/api/restaurant/stock-reports/summary'

// Stock Report Downloads (backend-generated PDF / CSV)
export const STOCK_REPORTS_DOWNLOAD = '/api/stockreports'

// Order Reports
export const ORDER_REPORTS_BY_STATUS = '/api/restaurant/order-reports/by-status'
export const ORDER_REPORTS_BY_DATE = '/api/restaurant/order-reports/by-date'
export const ORDER_REPORTS_SUMMARY = '/api/restaurant/order-reports/summary'

// Menu Item Reports
export const MENUITEM_REPORTS_POPULAR = '/api/restaurant/menuitem-reports/popular'
export const MENUITEM_REPORTS_SALES = '/api/restaurant/menuitem-reports/sales'
export const MENUITEM_REPORTS_SUMMARY = '/api/restaurant/menuitem-reports/summary'

// Company Configurations
export const COMPANY_CONFIGURATIONS = '/api/restaurant/company-configurations'